__webpack_require__.p = "/om/ar/customer-service/returns-claims/spareparts/";